import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../config';
import { TextInputField } from '../../../commons/Inputs';

let App = window.App;
let $ = window.jQuery;

export default class CreateChartModal extends Component {
    state = {
        isSaving: false,
        chartName: ''
    };

    handleCloseModal = () => {

    };

    handleClick = () => {
        this.setState({
            isSaving: true
        });

        let url = `${config.apiUrl}dental/chartings`;
        let data = {
            chart_name: this.state.chartName,
            patient_id: this.props.patientId
        };

        axios.post(url, data).then((res) => {
            console.log(res.data.data);
            this.props.getCharts();

            this.setState({
                isSaving: false
            });

            App.alert({
                container: '#create-charting-modal-container',
                place: 'append',
                type: 'success',
                message: 'Successfully created a new chart',
                close: '1',
                reset: '1',
                focus: '1',
                closeInSeconds: '10',
                icon: 'check'
            });

            $('#createChart').modal('hide');

        }).catch((error) => {
            console.log(error);

            this.setState({
                isSaving: false
            });

            App.alert({
                container: '#create-charting-modal-container',
                place: 'append',
                type: 'danger',
                message: 'Failed to create a chart',
                close: '1',
                reset: '1',
                focus: '1',
                closeInSeconds: '10',
                icon: 'warning'
            });

            $('#createChart').modal('hide');
        });
    };

    render() {
        return (
            <div id="createChart" data-width="500" className="modal fade in"
                 tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.handleCloseModal}
                                data-dismiss="modal" aria-hidden="true"/>

                        <h4 className="modal-title">Create New Chart</h4>
                    </div>
                    <div className="modal-body">

                        <div id="create-charting-modal-container" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="row">
                            <div className="col-md-12">
                                <TextInputField id="mobile_number" label="Chart Name"
                                                help="Input Chart Name"
                                                onChange={(e) => {this.setState({chartName: e.target.value})}}
                                                val={this.state.chartName} />
                            </div>
                        </div>
                    </div>

                    { this.state.isSaving ? (
                        <div className="modal-footer">
                            <button type="button" data-dismiss="modal" className="btn dark btn-outline" disabled>
                                Close
                            </button>
                            <button type="button" className="btn green" disabled>
                                <i className="fa fa-spinner fa-spin" aria-hidden="true"/> &nbsp;
                                Saving
                            </button>
                        </div>
                    ) : (
                        <div className="modal-footer">
                            <button type="button" className="btn dark btn-outline" onClick={this.handleCloseModal}
                                    data-dismiss="modal">
                                Close
                            </button>
                            <button type="button" className="btn green" onClick={this.handleClick}>
                                Save
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Charting/CreateChartModal.js
 **/